import { Loader2 } from "lucide-react";

const LoadingSpinner = ({ size = "default", text = "" }) => {
  const sizeClasses = {
    small: "w-4 h-4",
    default: "w-6 h-6",
    large: "w-8 h-8",
  };

  return (
    <div className="flex items-center justify-center gap-3 p-8">
      <Loader2 className={`${sizeClasses[size]} text-blue-600 animate-spin`} />
      {text && <span className="text-gray-600 font-medium">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;
